// extracted by mini-css-extract-plugin
export default {"vimeo":"aP6RHw"};